import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'
import { type PayrollProviderConfig } from 'utils/web_api.schemas'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

export function getPayrollProviderConfigsQueryKey () {
  return ['payroll_provider_configs']
}

export function useGetPayrollProviderConfigs () {
  return useQuery<PayrollProviderConfig[], GrapeAPIErrorType>({
    queryKey: getPayrollProviderConfigsQueryKey(),
    queryFn: async () => {
      const response = await fetchWithHeaders('/api/web/admin/payroll_provider_configs')
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
  })
}
